"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Avatar_1 = __importDefault(require("@mui/material/Avatar"));
const react_1 = __importDefault(require("react"));
const themes_1 = require("../../themes");
const Avatar = ({ name = 'No Name' }) => {
    const initialsArr = name
        .split(' ')
        .map((n) => n.slice(0, 1))
        .slice(0, 2);
    const initials = initialsArr.join('');
    const initialsCharCodeSum = initialsArr
        .map((c, i) => c.charCodeAt(0) * (i + 1) * 10)
        .reduce((sum, v) => sum + v, 0);
    const theme = (0, themes_1.useTheme)();
    if (true) {
        return (react_1.default.createElement(Avatar_1.default, { sizes: "32px", sx: {
                width: 32,
                height: 32,
                fontSize: theme.typography.fontSize,
                fontWeight: 'bold',
                backgroundColor: `hsl(${initialsCharCodeSum % 360},59%,46%)`,
            } }, initials));
    }
};
exports.default = Avatar;
